import type { DailyTacticalReadiness } from '../../services/operationsApi';
import type { DtsSummary } from '../../services/fableLabApi';
import { cohortLabel, formatKst } from './fableLabels';

const STATUS_LABEL: Record<string, string> = {
  COMPLETED: '완료',
  FAILED: '실패',
  PENDING: '대기',
  RUNNING: '실행 중',
};

/** 기록 묶음별 건수와 최근 실행 목록. */
export default function FableRuns({ readiness, summary, summaryError }: Props) {
  const cohortRows = [
    ['공식 관찰', readiness.official_cohort_id, readiness.cohorts.official_run_count],
    ['사전 리허설', readiness.rehearsal_cohort_id, readiness.cohorts.rehearsal_run_count],
    ['배관 테스트', readiness.plumbing_cohort_id, readiness.cohorts.plumbing_run_count],
  ] as const;
  return (
    <section className="fable-panel">
      <header className="fable-panel-head">
        <h3>어떤 기록이 얼마나 쌓였나</h3>
        <p>기록 묶음(cohort)은 같은 조건으로 만든 실험 기록의 모음입니다.</p>
      </header>
      <div className="fable-cohort-grid">
        {cohortRows.map(([label, id, count]) => (
          <div key={id} className="fable-cohort-cell">
            <strong>{label}</strong>
            <span className="fable-cohort-count">{count}건</span>
            <code>{id}</code>
          </div>
        ))}
      </div>
      <h4 className="fable-subhead">최근 실행 기록</h4>
      {summaryError && <p className="fable-error">API 오류: {summaryError}</p>}
      {!summaryError && (!summary || summary.recent_runs.length === 0) && (
        <p className="fable-empty">데이터 없음</p>
      )}
      {summary && summary.recent_runs.length > 0 && (
        <ul className="fable-run-list">
          {summary.recent_runs.map((run) => (
            <li key={run.id}>
              <strong>{run.trading_date}</strong>
              <span className="fable-tag">{cohortLabel(run.cohort_id)}</span>
              <span className={`fable-run-status s-${run.status.toLowerCase()}`}>
                {STATUS_LABEL[run.status] || run.status}
              </span>
              <small>기록 시각: {formatKst(run.created_at)} (한국시간)</small>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}

type Props = {
  readiness: DailyTacticalReadiness;
  summary: DtsSummary | null;
  summaryError: string | null;
};
